import { create } from "zustand"

interface PriceChangeTablesState {
  tableChanges: Record<string, boolean>
  selectedCounts: Record<string, number>
  resetVersion: number
  isFetching: boolean
}

interface PriceChangeTablesActions {
  reset: () => void
  setTableChange: (id: string, hasChanges: boolean) => void
  setSelectedCount: (id: string, count: number) => void
  setIsFetching: (isFetching: boolean) => void
}

const INITIAL_STATE: PriceChangeTablesState = {
  tableChanges: {},
  selectedCounts: {},
  resetVersion: 0,
  isFetching: false,
}

export const usePriceChangeTablesStore = create<PriceChangeTablesState & PriceChangeTablesActions>((set) => ({
  ...INITIAL_STATE,

  reset: () =>
    set((state) => ({
      tableChanges: {},
      selectedCounts: {},
      resetVersion: state.resetVersion + 1,
    })),

  setTableChange: (id, hasChanges) =>
    set((state) => {
      if (state.tableChanges[id] === hasChanges) return state
      return { tableChanges: { ...state.tableChanges, [id]: hasChanges } }
    }),

  setSelectedCount: (id, count) => set((state) => ({ selectedCounts: { ...state.selectedCounts, [id]: count } })),

  setIsFetching: (isFetching) => set({ isFetching }),
}))
